export const scrollIntoView = (
  element: Element,
  options: ScrollIntoViewOptions = {}
) => {
  try {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      ...options,
    });
  } catch (error) {
    //fallback to prevent browser crashing
    element.scrollIntoView(false);
  }
};
